import { connect } from 'react-redux'

import {
  fetchSuggestions,
  makeSelectSuggestions,
} from '../../redux/modules/autocomplete'

export default function connectAutocomplete(type, Component) {
  const mapStateToProps = () => {
    const selectSuggestions = makeSelectSuggestions()

    return (state, ownProps) => ({
      suggestions: selectSuggestions(state, {
        query: ownProps.value,
        type,
      }),
    })
  }

  const mapDispatchToProps = dispatch => ({
    onSuggestionsFetchRequested: ({ value }) => dispatch(fetchSuggestions(type, value)),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Component)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Form/connectAutocomplete.js